<template>
  <div id="grid-capacitacion">
    <v-layout>
      <v-flex xs4>
        <v-btn
          v-if="
            (proceso == 'CAPACITACION' && usuarioLoggedTipe == 'PROVEEDOR') ||
            usuarioLoggedTipe == 'ADMINISTRADOR' ||
            usuarioLoggedTipe == 'AGENCIA'
          "
          color="primary"
          @click="descargaCapacitacion()"
          >Descarga Plantilla Edición</v-btn
        >
      </v-flex>
      <v-flex xs4 grid-list-xl>
        <v-toolbar-title
          v-if="
            (proceso == 'CAPACITACION' && usuarioLoggedTipe == 'PROVEEDOR') ||
            usuarioLoggedTipe == 'ADMINISTRADOR' ||
            usuarioLoggedTipe == 'AGENCIA'
          "
          class="indigo--text"
          >Carga masiva Edición</v-toolbar-title
        >
        <data-adjunto
          v-if="
            (proceso == 'CAPACITACION' && usuarioLoggedTipe == 'PROVEEDOR') ||
            usuarioLoggedTipe == 'ADMINISTRADOR' ||
            usuarioLoggedTipe == 'AGENCIA'
          "
          :documentoId="id"
          :tipeView="tipeView"
          :tipeArchive="tipeArchive"
        ></data-adjunto>
      </v-flex>
      <v-flex xs1>
        <v-btn
          v-if="
            (botonCargar == true &&
              proceso == 'CAPACITACION' &&
              usuarioLoggedTipe == 'PROVEEDOR') ||
            usuarioLoggedTipe == 'ADMINISTRADOR' ||
            usuarioLoggedTipe == 'AGENCIA'
          "
          depressed
          outline
          icon
          fab
          dark
          color="primary"
          medium
          title="Cargar planilla"
          @click="validarArchivo()"
        >
          Validar
        </v-btn>
      </v-flex>
      <v-flex xs3>
        <v-btn
          v-if="botonProcesar == true"
          color="primary"
          dark
          class="mb-2"
          @click="procesarArchivo()"
        >
          Cargar
        </v-btn>
      </v-flex>
    </v-layout>

    <v-container grid-list-xl fluid>
      <v-layout class="d-flex pa-2">
        <div class="d-flex pa-2" xs12 sm6>
          <v-text-field
            width="300px"
            v-model="txtBusqueda"
            label="Ingresa el nombre o código para la busqueda por palabra clave"
            single-line
          ></v-text-field>
          <v-btn
            color="primary"
            @click="loadData()"
            :disabled="txtBusqueda.length < 3"
            ><v-icon dark left>search</v-icon>Buscar</v-btn
          >
          <v-btn
            color="secondary"
            @click="limpiaBuscador()"
            :disabled="txtBusqueda.length < 3"
            class="shrink"
            ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
          >
        </div>
      </v-layout>

      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsDocumento"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left" nowrap>
                {{ props.item.rut + "-" + props.item.dv }}
              </td>
              <td class="text-xs-left">
                {{
                  props.item.rolCapId != null
                    ? props.item.rolCapId.descripcion
                    : "-"
                }}
              </td>
              <td class="text-xs-left">
                {{ matricula(props.item.tipoMatricula) }}
              </td>
              <td class="text-xs-left">{{ props.item.apto }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Ver reclutado"
                  @click="viewCandidato(props.item.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    (proceso == 'CAPACITACION' &&
                      usuarioLoggedTipe == 'PROVEEDOR') ||
                    usuarioLoggedTipe == 'ADMINISTRADOR' ||
                    usuarioLoggedTipe == 'AGENCIA'
                  "
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Editar reclutado"
                  @click="editCandidato(props.item.id)"
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>

          <v-card-actions
            v-if="
              proceso == 'CAPACITACION' &&
              (usuarioLoggedTipe == 'PROVEEDOR' ||
                usuarioLoggedTipe == 'ADMINISTRADOR' ||
                usuarioLoggedTipe == 'AGENCIA')
            "
            class="pb-3"
          >
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >&nbsp;Ver reclutados
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="primary"
              small
            >
              <v-icon>open_in_new</v-icon> </v-btn
            >&nbsp;Editar reclutados
          </v-card-actions>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="itemsDocumento.length"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="9"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          v-if="botonDescarga == true"
          color="primary"
          @click="descargaMasiva()"
          >Descarga</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline"
          >Resumen Rut de Reclutados Registrados</v-card-title
        >
        <v-card-text>
          <v-flex lg12>
            <v-spacer></v-spacer>
            <v-card-title style="font-weight: bold">Rut válidos</v-card-title>
            <v-list>
              <v-list-item v-for="item in rutValid" :key="item">
                <v-list-item-content>
                  <v-list-item-title v-text="item"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-title style="font-weight: bold">Rut Invalidos</v-card-title>
            <v-list>
              <v-list-item v-for="item in rutNoValid" :key="item">
                <v-list-item-content>
                  <v-list-item-title v-text="item"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeModal()"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogLoading" persistent max-width="390">
      <loading-descarga></loading-descarga>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import DataAdjunto from "@/components/AdjuntoData.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-capacitacion",

  components: {
    AlertEmpty,
    LoadingDescarga,
    Loading,
    DataAdjunto,
  },
  props: {
    rowsTable: "",
    tipeView: "",
  },

  data() {
    return {
      txtBusqueda: "",
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      dialogLoading: false,
      loading: false,
      alerta: false,
      dialog: false,
      botonDescarga: false,
      item: [],
      id: "",
      tipeArchive: "",
      idContrato: "",
      itemsProgreso: [],
      headers: [
        { text: "Rut", align: "left", sortable: false, value: "rut" },
        { text: "Rol Capacitado", sortable: false, value: "cargo" },
        { text: "Forma Capacitación", sortable: false, value: "forma_cap" },
        { text: "Resultado Capacitación", sortable: false, value: "apto" },
        { text: "Accion", sortable: false, value: "" },
      ],
      usuarioLoggedTipe: "",
      itemsDocumento: [],
      idUserLogged: "",
      proceso: "",
      tab: "",
      rutValid: [],
      rutNoValid: [],
      botonProcesar: false,
      botonCargar: true,
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  created() {
    this.tipeArchive = "*";
    this.tab = this.$store.getters.subTabSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.loadData();
  },

  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    matricula(tipoMatricula) {
      if (tipoMatricula == 1) {
        return "PRESENCIAL";
      }
      if (tipoMatricula == 2) {
        return "ABREVIADA";
      }
      if (tipoMatricula == 3) {
        return "B-LEARNING";
      }
      return "";
    },

    async loadCandidatosFilter() {
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
        origenBusqueda: this.tab,
      };
      return await axios
        .post("/candidatos/filterTxt", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsDocumento = await this.loadCandidatosFilter();
      this.miPaginacion.totalItems = this.itemsDocumento.length;

      if (this.itemsDocumento !== undefined && this.itemsDocumento.length > 0) {
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    closeModal() {
      this.loading = true;
      this.dialog = false;
      if (this.rutNoValid.length > 0) {
        this.botonProcesar = false;
        this.botonCargar = true;
      } else {
        this.botonProcesar = true;
        this.botonCargar = false;
      }
      this.loading = false;
    },
    async validarArchivo() {
      this.resp = await this.preProcessFile();
      this.rutValid = this.resp.validRuts;
      this.rutNoValid = this.resp.NoValidRuts;
      this.dialog = true;
    },
    async preProcessFile() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        excelFile: base64EncodedStr,
        idContrato: idContrato,
        proceso: this.proceso,
      };
      return await axios
        .post("/candidatos/preProcessFile", this.body)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
        });
    },
    async procesarArchivo() {
      this.resp = await this.processMasiveEdit();
      this.reload();
    },
    async processMasiveEdit() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        excelFile: base64EncodedStr,
        idContrato: idContrato,
        proceso: this.proceso,
      };
      return await axios
        .post("/candidatos/editarDesdeArchivoSeleccionCapacitacion", this.body)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
        });
    },
    descargaCapacitacion() {
      this.dialogLoading = true;
      axios
        .get(
          "/candidatos/downloadPlanillaEdicionMCapacitacion/" + this.idContrato,
          { responseType: "blob" }
        )
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute(
            "download",
            "PLANILLA_APLI_SELECCION_CAPACITACION.xlsx"
          );
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    descargaMasiva() {
      this.dialogLoading = true;
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
        origenBusqueda: this.tab,
      };
      axios
        .post("/candidatos/downloadExcel", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_CAPACITACION.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiaBuscador() {
      this.txtBusqueda = "";
      this.loadData();
    },
    viewCandidato(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "CandidatosRegistra",
          params: { id: id, tipeView: "consulta" },
        });
      }, 1000);
    },
    editCandidato(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "CandidatosRegistra",
          params: { id: id, tipeView: "modifica" },
        });
      }, 1000);
    },
    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
        // this.$router.go(-1)
      }, 1000);
    },
  },
};
</script>
